import ConfirmButtonMutation, {
  ConfirmButtonMutationProps,
} from "components/Templates/ConfirmButtonMutation"
import React from "react"
/*

Gives three options to the user
1. SAVE - hits the mutation and redirects
2. save and continue editing - hits the mutation and preserves the state
3. save and add another - hits the mutation and refreshes the state

Props
1. mutation - the actual mutation to hit
2. variables - the variables required for the mutation
3. edit - whether the entry already exists or not
5. onError - callback fired when the mutation fails
6. update - callback fired when the mutation succeed and the user wants to update the cache manually
6. refetchQueries - takes queries in order to update the cache easily
4. onSave - the callback fired after clicking the 'SAVE' button
5. onSaveAndEdit - the callback fired after clicking the 'SAVE and Continue Editing' button
6. onSaveAndAdd - the callback fired after clicking the 'SAVE and add another' button
*/

export interface MutationOptionsProps extends ConfirmButtonMutationProps {
  onSave?: (data: any) => void | undefined
  onSaveAndEdit?: (data: any) => void | undefined
  onSaveAndAdd?: (data: any) => void | undefined
  className?: string
}
const MutationOptions = ({
  onSave = undefined,
  onSaveAndEdit = undefined,
  onSaveAndAdd = undefined,
  className = undefined,
  addConfirmation = false,
  ...MutationProps
}: MutationOptionsProps) => {
  return (
    <div className={`flex justify-end ${className}`}>
      {onSaveAndAdd && (
        <ConfirmButtonMutation
          {...MutationProps}
          addConfirmation={addConfirmation}
          dark={false}
          intent="primary"
          onCompleted={onSaveAndAdd}
          className="mr-3"
        >
          Save and Add Another
        </ConfirmButtonMutation>
      )}
      {onSaveAndEdit && (
        <ConfirmButtonMutation
          {...MutationProps}
          addConfirmation={addConfirmation}
          dark={false}
          intent="primary"
          onCompleted={onSaveAndEdit}
          className="mr-3"
        >
          Save and Continue Editing
        </ConfirmButtonMutation>
      )}
      {onSave && (
        <ConfirmButtonMutation
          {...MutationProps}
          id="mutation_button"
          onCompleted={onSave}
          addConfirmation={addConfirmation}
        >
          SAVE
        </ConfirmButtonMutation>
      )}
    </div>
  )
}

export default MutationOptions
